import { groupBy, orderBy, uniq } from "lodash";
import L from 'leaflet';
import { useLogic } from "../../../../../../../../../Components/ordemLaboratorio/mapaFertilidade/useLogic";
import { ResultadoAnaliseOS__Item } from "../../../../../../../../../services/AgriculturaPrecisao/bookResumido/GET";
import { Item__MapaFertilidade__Config } from "../../../../../../../../../services/novoConfigBook/get";
import { ItensMapaFertilidadeTypes } from "../../../../../../../../../services/Laboratorio/osResultado";
import SlowKrigagemBookResumido from 'worker-loader!../../../../../../../../../Components/ordemLaboratorio/mapaFertilidade/slowOverlay.worker';
import { geraOverlayView, tryError } from "../../../../../../../../../services/Afins";
import { errorAlert } from "../../../../../../../../../utils/alert";
import { obterListaSumario2 } from "../components/sumario/meta";
import { replceCalcarioDescription } from "./page_elemento";

//TYPES
type TypeDadosKrigagem = {
    bounds: any
    circle: any
    dataProfundidade: any
    qualidade_definicao_book: number
    krigagem: {
        coord: any[]
        points: any[]
        colors: any[]
        descriptionElemento: string
        ordem: number,
        valor_interpretado: any
    }[]
}

export function gerarKrigagem( //NOSONAR
    lista_dados_os: ResultadoAnaliseOS__Item[],
    tipo_representacao: 'Interpretado' | 'Distribuído',
    config_book: Item__MapaFertilidade__Config[],
    setLoading_book: Function,
    qualidade_definicao_book: number,
    setPolygon: Function,
    talhoes_selecionados: { cod_talhao: number, nome_talhao: string, coordenadas: { latitude: number, longitude: number }[] }[],
    setKrigagem_processada: Function,
    setProfundidades_agrupadas: Function,
    profundidades_filtrar_selecionadas: string[]
) {

    const cod_prescricoes = new Set([30, 31, 32, 41, 42, 43, 44, 45, 46, 49]);
    const cod_indicadores = new Set([28, 33, 34, 38, 50]);
    const cods_q_devem_ser_reverso = [7, 18, 25, 26, 28, 30, 31, 32, 41, 42, 43, 44, 45, 46, 49, 50];
    const cod_indicadores_e_precricoes = [30, 31, 32, 49, 41, 42, 46, 43, 44, 45, 33, 34, 28, 38, 50];
    const { generateColors } = useLogic();

    // 00° - FILTRAR APENAS PROFUNDIDADES SELECIONADAS E INDICADORES E PRESCRIÇÕES --------------------------------------------------------------------------------->
    // console.log("lista_dados_os: ", lista_dados_os)
    let apenas_profundidades_selecionadas = profundidades_filtrar_selecionadas.length > 0
        ? lista_dados_os.filter(item => profundidades_filtrar_selecionadas.includes(item.profundidade) || cod_indicadores_e_precricoes.includes(item.cod_elemento))
        : lista_dados_os;
    // console.log("00 - apenas_profundidades_selecionadas: ", apenas_profundidades_selecionadas)
    // 01° - REMOVER VALORES NULOS --------------------------------------------------------------------------------------------------------------------------------->

    let remover_nulos = (apenas_profundidades_selecionadas ?? []).filter((item) =>
        tipo_representacao === 'Interpretado' ? (item.valor_interpretado !== null || cod_prescricoes.has(item.cod_elemento)) : item.valor_distribuido !== null
    );
    // console.log("01 - remover_nulos: ", remover_nulos)

    // 02° - ORDENAR LISTA DE ELEMENTOS DE ACORDO COM AS CONFIGURAÇÕES DO BOOK ------------------------------------------------------------------------------------->

    let montar_lista_elementos_com_ordem = remover_nulos.map((item) => {
        let encontrar_elemento = config_book.find(config => Number(config.elemento) === Number(item.cod_elemento));

        if (encontrar_elemento) {
            item.ordem = encontrar_elemento.secoes?.[0]?.ordem
        }
        else {
            item.ordem = null
        }
        return item;
    })

    let ordenar_elementos = orderBy(montar_lista_elementos_com_ordem, (item) => Number(item.ordem));
    // console.log("02 - ordenar_elementos: ", ordenar_elementos)

    // 03° - SEGREGAR POR PROFUNDIDADES OU INDICADORES OU PRESCRIÇÕES ---------------------------------------------------------------------------------------------->

    let zero_a_vinte__00__20 = ordenar_elementos.filter((item) => item.profundidade === '00-20' && !cod_indicadores_e_precricoes?.includes(item.cod_elemento));
    let vinte_a_quarenta__20__40 = ordenar_elementos.filter((item) => item.profundidade === '20-40' && !cod_indicadores_e_precricoes?.includes(item.cod_elemento));
    let zer_a_cinquenta__00__50 = ordenar_elementos.filter((item) => item.profundidade === '00-50' && !cod_indicadores_e_precricoes?.includes(item.cod_elemento));
    let MICRO = ordenar_elementos.filter((item) => item.profundidade === 'micro' && !cod_indicadores_e_precricoes?.includes(item.cod_elemento));
    let PRESCRICOES = ordenar_elementos.filter(item => cod_prescricoes.has(item.cod_elemento));
    let INDICADORES = ordenar_elementos.filter(item => cod_indicadores.has(item.cod_elemento));

    // 04° - MONTAR OBJETO CONTENDO AS PROFUNDIDADES AGRUPADAS -----------------------------------------------------------------------------------------------------> 

    let profundidades_agrupadas: { [key: string]: ItensMapaFertilidadeTypes[] } = {};

    const grupos: any = [
        ['00-20', zero_a_vinte__00__20],
        ['20-40', vinte_a_quarenta__20__40],
        ['00-50', zer_a_cinquenta__00__50],
        ['micro', MICRO],
        ['prescricoes', PRESCRICOES],
        ['indicadores', INDICADORES],
    ];

    for (const [nome_profundidade, array_segregado] of grupos) {
        if (array_segregado.length > 0) {
            profundidades_agrupadas[nome_profundidade] = array_segregado;
        }
    }
    // console.log("04 - profundidades_agrupadas: ", profundidades_agrupadas)
    setProfundidades_agrupadas(profundidades_agrupadas);

    // 05° - TRANSFORMAR OBJETO EM ARRAY UTILIZAVEL ----------------------------------------------------------------------------------------------------------------> 

    function AgruparElementosPrecricao(dados_prescricao: ItensMapaFertilidadeTypes[]) {

        let result = dados_prescricao.reduce((acc, curr) => {

            const newEntry = {
                classificacao: curr.classificacao,
                cod_elemento: curr.cod_elemento,
                cod_elemento_pedido: curr.cod_elemento_pedido,
                // cod_profundidade: curr.cod_profundidade,
                cod_pedido: curr.cod_pedido,
                cod_propriedade: curr.cod_propriedade,
                // cod_safra_conta: curr.cod_safra_conta,
                create_time: curr.create_time,
                // create_user: curr.create_user,
                delete_time: curr.delete_time,
                // delete_user: curr.delete_user,
                elemento: curr.elemento,
                elemento_descricao: curr.elemento_descricao === 'Calcário' ? `${curr.elemento_descricao} ${curr.profundidade}` : `${curr.elemento_descricao}`,
                cod_elemento_descricao: curr.cod_elemento === 30 ? `${curr.cod_elemento} | ${curr.profundidade}` : curr.cod_elemento,
                latitude: curr.latitude,
                limite_maximo: curr.limite_maximo,
                limite_minimo: curr.limite_minimo,
                longitude: curr.longitude,
                maximo: curr.maximo,
                media: curr.media,
                minimo: curr.minimo,
                observacao: curr.observacao,
                ordem: curr.ordem,
                ponto: curr.ponto,
                profundidade: curr.profundidade,
                qualidade: curr.qualidade,
                // unidade: curr.unidade,
                // update_time: curr.update_time,
                // update_user: curr.update_user,
                // uso_mapa: curr.uso_mapa,
                valor: curr.valor,
                valor_distribuido: curr.valor_distribuido,
                valor_interpretado: cod_prescricoes.has(curr.cod_elemento) ? curr.valor_distribuido : curr.valor_interpretado
            };
            return [...acc, newEntry];
        }, []);

        return result
    }

    let lista_de_profundidades = Object.entries(profundidades_agrupadas).map(([_nome_profundidade, array_segregado]) => {

        if (array_segregado.length > 0) {
            const ordenado = orderBy(array_segregado, (item) => { return Number(item.ordem) })

            return groupBy(AgruparElementosPrecricao(ordenado), 'cod_elemento_descricao')

        }
    })
    // 06° - PROCESSARAR DADOS COM SERVICE-WORKER ---------------------------------------------------------------------------------------------------------->

    function obterOrdem(cod_elemento: number): number | null | undefined {
        let elemento = (config_book ?? [])?.find((item) => item.elemento === cod_elemento);
        return elemento?.secoes?.[0]?.ordem;
    }

    const overLayGera = async ({ grid, colors, lats, longs }) => {
        let overlay: { url: string; bounds: any; key: any; colors: any }
        if (colors.length > 1) {
            overlay = await geraOverlayView(grid, lats, longs, colors)
        } else {
            overlay = { key: null, url: null, colors, bounds: null }
        }

        return overlay
    }


    if (lista_de_profundidades.length > 0) {

        const processarDados = async () => {
            setLoading_book(true);

            let dados_krigagem: TypeDadosKrigagem[] = [];

            function obterValorEncontrado(cod_elemento: number, valor_interpretado: string, valor_distribuido: string): number {
                if (tipo_representacao === 'Distribuído') {
                    return Number(valor_distribuido);
                }
                return cod_prescricoes.has(cod_elemento) ? Number(valor_distribuido) : Number(valor_interpretado)
            }

            function obterTipodeMapa(key: string): boolean {
                if (cod_prescricoes.has(Number(key))) {
                    return false;
                }
                return (key === '30 | 00-30') ? false : (tipo_representacao === 'Interpretado');
            }

            function obterCoordenadasTalhoes(coordenadas: any[]) {
                let estrutura = (coordenadas ?? []).map((main_item) => {
                    return (main_item?.coordenadas ?? []).map((item) => { //NOSONAR
                        return {
                            latitude: item?.latitude,
                            longitude: item?.longitude
                        }
                    })
                });

                let estrutura_com_ligacao = [...estrutura];

                // Pegando um ponto de cada polígono para criar a ligação
                let ligacao = estrutura.map(polygon => polygon[0]);

                // Adicionando a ligação ao array principal
                estrutura_com_ligacao.push(ligacao);

                //@ts-ignore 
                return estrutura_com_ligacao.flat() ?? [];
            }

            let ligar_talhoes = obterCoordenadasTalhoes(talhoes_selecionados);

            //@ts-ignore
            let coordenadas_talhoes = ligar_talhoes;

            for (const elemento of lista_de_profundidades) {

                const dados_do_elemento = elemento;
                const index = Object.keys(dados_do_elemento)[0];
                const circle = dados_do_elemento[index];

                const latLng: L.LatLngTuple[] = circle.map((item) => {
                    return [Number(item.latitude), Number(item.longitude)]
                });

                const polygon = new L.Polygon(latLng, {});
                const bounds = polygon.getBounds();

                dados_krigagem = [
                    ...dados_krigagem,
                    {
                        bounds: bounds,
                        circle: latLng,
                        dataProfundidade: circle,
                        qualidade_definicao_book: qualidade_definicao_book,
                        krigagem: await Promise.all(
                            Object.entries(dados_do_elemento).map(async ([key, value]) => {

                                const reverse: boolean = cods_q_devem_ser_reverso.indexOf(Number(key?.split('|')?.[0])) > -1;

                                const colors = uniq(generateColors(
                                    value.map((item) =>
                                        obterValorEncontrado(item.cod_elemento, item.valor_interpretado, item.valor_distribuido)
                                    ),
                                    obterTipodeMapa(key),
                                    !reverse
                                )
                                )


                                const lastColor = colors[colors.length - 1]

                                colors.push(lastColor);

                                function obterValorDistribuido(cod_elemento: number, valor_distribuido: string, valor_interpretado: string): string {
                                    if (tipo_representacao === 'Distribuído') {
                                        return valor_distribuido;
                                    }
                                    return cod_prescricoes.has(cod_elemento) ? valor_distribuido : valor_interpretado;
                                }

                                const pontos = value.map((item) => {
                                    return {
                                        lat: Number(item.latitude),
                                        lng: Number(item.longitude),
                                        ponto: String(item.ponto),
                                        valor: item.valor,
                                        valorDistribuido: obterValorDistribuido(item.cod_elemento, item.valor_distribuido, item.valor_interpretado)
                                    }
                                })

                                const coord = (coordenadas_talhoes ?? []).map(({ longitude, latitude }) => {
                                    return [Number(longitude), Number(latitude)]
                                })

                                const poly: L.LatLngExpression[] = (coordenadas_talhoes ?? []).map(({ longitude, latitude }) => {
                                    return { lat: Number(latitude), lng: Number(longitude) }
                                })

                                setPolygon(poly)

                                const valuesDis = value.map((rec) =>
                                    obterValorDistribuido(rec.cod_elemento, rec.valor_distribuido, rec.valor_interpretado)
                                )

                                const points = [
                                    {
                                        t: valuesDis,
                                        x: pontos.map((rec) => rec.lng),
                                        y: pontos.map((rec) => rec.lat),
                                    },
                                ];

                                const krig = {
                                    coord,
                                    points,
                                    colors,
                                    descriptionElemento: replceCalcarioDescription(value[0].elemento_descricao),
                                    ordem: obterOrdem(value[0].cod_elemento) ?? Number(value[0].ordem),
                                    valor_interpretado: (value ?? []).map(item => item.valor_interpretado)
                                }
                                return krig
                            })
                        ),
                    },
                ];
            }

            const webWorkerBookResumido = new SlowKrigagemBookResumido();

            webWorkerBookResumido.onmessage = async (e) => {

                if (e.data?.error) {
                    webWorkerBookResumido.terminate()
                    setLoading_book(false);
                    console.log("Erro capturado do Worker:", e.data.error);
                    errorAlert('Erro no processamento do Worker!')
                    tryError(e.data.error)
                    return;
                }

                const data_worker: {
                    bounds: L.LatLngBounds
                    circle: L.LatLngTuple[]
                    dataProfundidade: ItensMapaFertilidadeTypes[]
                    krigagem: { grid; lats; longs; colors; descriptionElemento; ordem, valor_interpretado, teste }[]
                }[] = e.data

                try {
                    const overlayView = (data_worker ?? [])?.map?.(async (rec) => {
                        const response = (rec?.krigagem ?? []).map(async (item) => { //NOSONAR
                            const overlay = await overLayGera({ ...item })
                            return {
                                url: overlay?.url,
                                colors: uniq(overlay.colors),
                                descriptionElemento: item.descriptionElemento,
                                ordem: Number(item.ordem),
                                bounds: overlay.bounds, // falta esse
                                valor_interpretado: item.valor_interpretado
                            }
                        })
                        const resolve = await Promise.all(response)
                        return {
                            bounds: rec.bounds,
                            circle: rec.circle,
                            dataProfundidade: rec.dataProfundidade,
                            krigagem: orderBy(resolve, 'ordem'),
                            cod_pedido: rec?.dataProfundidade?.[0]?.cod_pedido ?? 0
                        }
                    })
                    // console.log("data_worker: ", data_worker)
                    // console.log("overlayView: ", overlayView)

                    if (!overlayView) {
                        throw new Error("Falha ao processar os dados do worker");
                    }

                    const resolve = await Promise.all(overlayView)

                    setKrigagem_processada(resolve);

                    setLoading_book(false)
                    webWorkerBookResumido.terminate()

                    // return resolve;
                }
                catch (error) {
                    webWorkerBookResumido.terminate()
                    setLoading_book(false);
                    console.error("Erro no Promise.all ou processamento do mapa:", error);
                    errorAlert('Erro ao gerar Grid!')
                    tryError(error)
                }
            }

            webWorkerBookResumido.postMessage({ command: 'message-book', dados: dados_krigagem })
            // webWorkerBookResumido.postMessage({ command: 'gerar-book-resumido-separado', dados: dados_krigagem })

        }


        processarDados();
    }
    else {
        setLoading_book(false);
        errorAlert('Nenhuma profundidade foi encontrada!')
    }
};


export function obterDefaultBounds(coordenadas: { latitude: number; longitude: number; }[]) {

    const coordenadas_no_padrao = (coordenadas ?? [])?.map(({ latitude, longitude }) => {
        return { lat: Number(latitude), lng: Number(longitude) }
    })

    const polygonFit = new L.Polygon(coordenadas_no_padrao, {})
    const fitBounds = polygonFit.getBounds()

    return fitBounds;

}


//TYPES
type typeKrigagemProcessada = {
    bounds: any,
    circle: number[],
    dataProfundidade: ItensMapaFertilidadeTypes[],
    krigagem: {
        url: string;
        colors: unknown[];
        descriptionElemento: any;
        ordem: number;
        bounds: any;
        valor_interpretado: any;
    }[]
};

function obterPaginaProfundidade(nome_profundidade_buscar: string, krigagem_processada: typeKrigagemProcessada[]) {

    let listagem_sumario = (obterListaSumario2(krigagem_processada, 'null'));
    let listagem_ajustada = listagem_sumario.map(({ nome_profundidade, pagina }) => {
        return {
            profundidade: nome_profundidade.match(/\b(00 a 20|20 a 40|00 a 30|Granulometria|micro|Prescrições|Indicadores)\b/gi)[0],
            pagina: pagina
        }
    });

    let nome_profundidade_buscar_replace = nome_profundidade_buscar?.replace("00 a 50", 'Granulometria')
    let profundidade_encontrada = listagem_ajustada.find(item => item.profundidade === nome_profundidade_buscar_replace);
    return profundidade_encontrada?.pagina ?? 0;
}

function obterPaginaElemento(nome_profundidade_buscar: string, nome_elemento_buscar: string, krigagem_processada: typeKrigagemProcessada[]) {

    let listagem_sumario = (obterListaSumario2(krigagem_processada, 'null'));
    let listagem_ajustada = listagem_sumario.map(({ nome_profundidade, lista_elementos }) => {
        return {
            profundidade: nome_profundidade.match(/\b(00 a 20|20 a 40|00 a 30|00 a 50|Granulometria|micro|Prescrições|Indicadores)\b/gi)[0],
            lista_elementos: lista_elementos
        }
    });

    let nome_profundidade_buscar_replace = nome_profundidade_buscar?.replace("00 a 50", 'Granulometria')
    let profundidade_encontrada = listagem_ajustada.find(item => item.profundidade === nome_profundidade_buscar_replace);

    let elemento_encontrado = (profundidade_encontrada?.lista_elementos ?? []).find(item => item?.nome_elemento === (nome_elemento_buscar + ':'));

    return elemento_encontrado?.pagina ?? 0;
}

export function listagemPaginas(krigagem_processada: typeKrigagemProcessada[]) {

    let pagina = 4;
    const cod_prescricoes = new Set([30, 31, 32, 41, 42, 43, 44, 45, 46, 49]);
    const cod_indicadores = new Set([28, 33, 34, 38, 50]);

    let apenas_profundidade = krigagem_processada.map((item, index) => {
        let contagem_paginas_elementos = index === 0 ? 0 : (item?.krigagem ?? []).length;
        let pagina_book = Number(pagina) + index + Number(contagem_paginas_elementos);
        pagina = pagina_book;

        let isIndicadores = (item.dataProfundidade).some(indi => cod_indicadores.has(indi.cod_elemento));
        let isPrescricoes = (item.dataProfundidade).some(indi => cod_prescricoes.has(indi.cod_elemento));
        let pagina_elementos = (item.krigagem).map((krigagem, index_elemento) => {
            return {
                ...krigagem,
                descriptionElemento: krigagem.descriptionElemento,
                pagina_elemento: obterPaginaElemento(nomeProfundidade(), krigagem.descriptionElemento, krigagem_processada)
            }
        })

        function nomeProfundidade() {
            if (isIndicadores) {
                return 'Indicadores'
            }
            if (isPrescricoes) {
                return 'Prescrições'
            }

            let profundidade = (item.dataProfundidade?.[0]?.profundidade)?.replace('-', ' a ');
            let pronfundidade_granulometria = profundidade?.replace("00 a 50", "Granulometria");

            return pronfundidade_granulometria;
        }
        function nomeProfundidadeRef() {
            if (isIndicadores) {
                return 'indicadores'
            }
            if (isPrescricoes) {
                return 'prescricoes'
            }

            let profundidade = (item.dataProfundidade?.[0]?.profundidade)?.replace('-', ' a ');

            return profundidade;
        }
        function nomeProfundidadePura() {
            if (isIndicadores) {
                return 'indicadores'
            }
            if (isPrescricoes) {
                return 'prescricoes'
            }

            let profundidade = (item.dataProfundidade?.[0]?.profundidade)

            return profundidade;
        }

        return {
            ...item,
            cod_profundidade: item.dataProfundidade?.[0]?.cod_propriedade,
            nome_profundidade: nomeProfundidade(),
            nome_profundidade_ref: nomeProfundidadeRef(),
            nome_profundidade_pura: nomeProfundidadePura(),
            pagina: obterPaginaProfundidade(nomeProfundidade(), krigagem_processada),
            is_indicadores: isIndicadores,
            is_prescricoes: isPrescricoes,
            pagina_elementos: pagina_elementos,

        }
    });

    return apenas_profundidade;
}

export function mesclarListagem(krigagem_processada_por_talhao: typeKrigagemProcessada[][], krigagem_processada: typeKrigagemProcessada[], talhoes_filtrados: number[]) {

    const cod_prescricoes = new Set([30, 31, 32, 41, 42, 43, 44, 45, 46, 49]);
    const cod_indicadores = new Set([28, 33, 34, 38, 50]);

    // console.log("krigagem_processada_por_talhao: ", krigagem_processada_por_talhao)

    // 01° - FILTRA TALHOES CASO TENHA ALGUM SELECINADO NO MODAL DE GERAR BOOK-------------------------------------------------------------------------------------->

    const filtrar_krigagem_por_talhao = talhoes_filtrados.length === 0 ? krigagem_processada_por_talhao : krigagem_processada_por_talhao.filter(item => {
        let cod = item[0]?.dataProfundidade[0]?.cod_pedido;
        return talhoes_filtrados.includes(cod);
    });

    // 02° MESCLA OS DADOS, AGRUPA POR PROFUNDIDADE, DEPOIS LISTA OS ELEMENTOS COM A INFO DE PROFUNDIDADE ---------------------------------------------------------->
    /**retorna o nome da profundida ou se ela for Indicadores ou Prescrição */
    function nomeProfundidade(cod_elemento: number, profundidade: string) {
        if (cod_prescricoes.has(cod_elemento)) return 'Prescrições';
        if (cod_indicadores.has(cod_elemento)) return 'Indicadores';
        return profundidade
    }
    /**cria uma ordem para a listagem das profundidades para forçar profundidades em primeiro, depois indicadores e por ultimo prescrições */
    function ordemProfundidade(cod_elemento: number): number {
        if (cod_prescricoes.has(cod_elemento)) return 3;
        if (cod_indicadores.has(cod_elemento)) return 2;
        return 1
    }

    // console.log("filtrar_krigagem_por_talhao: ", filtrar_krigagem_por_talhao)

    //@ts-ignore
    let mesclar_dados_talhoes = filtrar_krigagem_por_talhao.flat();
    // console.log("mesclar_dados_talhoes: ", mesclar_dados_talhoes)
    let incluir_profundidade = mesclar_dados_talhoes.map((item) => {
        return {
            ...item,
            profundidade: nomeProfundidade(item.dataProfundidade?.[0]?.cod_elemento, item.dataProfundidade?.[0]?.profundidade),
            cod_elemento: item.dataProfundidade?.[0]?.cod_elemento,
            ordem_profundidades: ordemProfundidade(item.dataProfundidade?.[0]?.cod_elemento)
        }
    })
    // console.log("incluir_profundidade: ", incluir_profundidade)
    let agrupar_por_profundidade = groupBy(orderBy(incluir_profundidade, 'ordem_profundidades', ['asc']), 'profundidade');
    let listar_por_profundidade = Object.entries(agrupar_por_profundidade).map(([profundidade, dados]) => {
        return {
            profundidade: profundidade,
            krigagens_profundidade: dados
        }
    })


    let estrutura_paginas = listar_por_profundidade.map(({ krigagens_profundidade }) => {

        // console.log("krigagens_profundidade: ", krigagens_profundidade)

        //@ts-ignore
        let mesclar_dataProfundidade = (krigagens_profundidade.map(i => i.dataProfundidade)).flat()
        let dataProfundidade_meclada: ItensMapaFertilidadeTypes[] = mesclar_dataProfundidade;
        let isIndicadores = (krigagens_profundidade).some(indi => cod_indicadores.has(indi.cod_elemento));
        let isPrescricoes = (krigagens_profundidade).some(indi => cod_prescricoes.has(indi.cod_elemento));

        function obterNomeProfundidade(tipo: 'tratado' | 'descricao' | 'original') {
            if (isIndicadores) return tipo === 'original' ? 'indicadores' : 'Indicadores';
            if (isPrescricoes) return tipo === 'original' ? 'prescricoes' : 'Prescrições';
            switch (tipo) {
                case 'tratado': {
                    const profun = (dataProfundidade_meclada?.[0]?.profundidade)?.replace('-', ' a ') ?? '';
                    return profun === '00 a 50' ? 'Granulometria' : profun || '';
                }
                case 'descricao':
                    return dataProfundidade_meclada?.[0]?.profundidade?.replace('-', ' a ');
                case 'original':
                    return dataProfundidade_meclada?.[0]?.profundidade
                default:
                    return ''
            }
        }

        let apenas_krigagens = krigagens_profundidade.map(item => item.krigagem);
        //@ts-ignore
        let mesclar_krigagens = apenas_krigagens.flat();

        let agrupar_por_elemento = groupBy(mesclar_krigagens, 'descriptionElemento');

        // console.log("mesclar_krigagens: ", mesclar_krigagens)
        // console.log("agrupar_por_elemento: ", agrupar_por_elemento)

        let listar_elementos = Object.entries(agrupar_por_elemento).map(([nome_elemento, dados]) => {

            let interpretados = dados.map((item) => item.valor_interpretado);

            let valor_interpretado_todos = {
                minimo: Math.min(...interpretados.map(item => item.minimo)),
                maximo: Math.max(...interpretados.map(item => item.maximo)),
                media: (interpretados.reduce((total, item) => total + item.media, 0)) / interpretados.length
            }

            return {
                descriptionElemento: nome_elemento,
                url: '',
                //@ts-ignore
                lista_urls: (dados.map(i => { return { url: i.url, bounds: i.bounds } })).flat(),
                //@ts-ignore
                colors: uniq((dados.map(i => i.colors)).flat()),
                ordem: dados?.[0]?.ordem,
                valor_interpretado: valor_interpretado_todos,
                pagina_elemento: obterPaginaElemento(obterNomeProfundidade('descricao'), nome_elemento, krigagem_processada)
            }
        });

        //@ts-ignore
        let mesclar_cricles = (krigagens_profundidade.map(i => i.circle)).flat();
        // console.log("dataProfundidade_meclada: ", dataProfundidade_meclada)
        return {
            dataProfundidade: dataProfundidade_meclada,
            circle: mesclar_cricles ?? [],
            krigagem: [],
            is_indicadores: isIndicadores,
            is_prescricoes: isPrescricoes,
            nome_profundidade: obterNomeProfundidade('descricao'),
            nome_profundidade_ref: obterNomeProfundidade('descricao'),
            nome_profundidade_pura: obterNomeProfundidade('original'),
            pagina: obterPaginaProfundidade(obterNomeProfundidade('descricao'), krigagem_processada),
            krigagens_profundidade: krigagens_profundidade,
            pagina_elementos: listar_elementos,
        }
    })

    // console.log("estrutura_paginas: ", estrutura_paginas)
    return estrutura_paginas ?? [];
}


export function obterValorDefinicao(qualidade_definicao_krigagem: 'Automática' | 'Definição baixa' | 'Definição padrão' | 'Definição melhorada', area_talhao: number) {
    function definicaoDaKrigagem(): number {
        if (Number(area_talhao) < (70)) {
            return 0.00003
        }
        if (Number(area_talhao) < (100)) {
            return 0.00004
        }
        if (Number(area_talhao) < (200)) {
            return 0.00005
        }
        if (Number(area_talhao) < (300)) {
            return 0.0001
        }
        if (Number(area_talhao) < (400)) {
            return 0.0002
        }
        if (Number(area_talhao) >= (400)) {
            return 0.0003
        }
    }

    switch (qualidade_definicao_krigagem) {
        case 'Automática':
            return definicaoDaKrigagem();
        case 'Definição baixa':
            return 0.0005;
        case 'Definição padrão':
            return 0.0003;
        case 'Definição melhorada':
            return 0.0001;

        default:
            return definicaoDaKrigagem();
    }
};

type typeTalhoes = {
    cod_talhao: number;
    cod_pedido: number;
    talhao_area: number;
    nome_talhao: string;
    coordenadas: {
        latitude: number;
        longitude: number;
    }[];
};

export function filtrarTalhoes(talhoes_selecionados: typeTalhoes[], talhoes_filtrados: number[]): typeTalhoes[] {
    if (talhoes_filtrados.length === 0) {
        return talhoes_selecionados;
    }

    let filtrar_talhoes = new Set(talhoes_filtrados);

    return talhoes_selecionados.filter(item => filtrar_talhoes.has(item.cod_pedido));
};

export function calcularAreaTalhoes(talhoes_selecionados: typeTalhoes[], talhoes_filtrados: number[]): number {

    if (talhoes_filtrados.length === 0) {
        let areas = talhoes_selecionados.reduce((acc, item) => acc + (item?.talhao_area ?? 0), 0)
        return areas ?? 0
    }


    let filtrar_talhoes = new Set(talhoes_filtrados);

    let talhoes = talhoes_selecionados.filter(item => filtrar_talhoes.has(item.cod_pedido));

    let areas = talhoes.reduce((acc, item) => acc + (item?.talhao_area ?? 0), 0)

    return areas ?? 0;
}